import React, {useEffect, useRef, useState} from "react";
import {ProcessCardStyled} from "../../styled/HowIWork";
import {useTheme} from "../UI/Theme/ThemeContext";
import BubbleImage from "../UI/BubbleFloat/BubbleImage";

const ProcessStep = ({ number, title, description, image }) => {
    const [isVisible, setIsVisible] = useState(false);
    const stepRef = useRef(null);
    const {themeName} = useTheme();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1 }
        );

        if (stepRef.current) {
            observer.observe(stepRef.current);
        }
    }, []);

    return (
        <ProcessCardStyled theme={themeName} ref={stepRef}>
            <h3>{number}. {title}</h3>
            {image && (
                    <BubbleImage img={image}/>

            )}
            <p>{description}</p>

        </ProcessCardStyled>
    );
};

export default ProcessStep;